import { hyphenateCpr } from "~/utils/string";

export default hyphenateCpr;
